








































































































































































import { Vue, Component, Emit, Prop, PropSync, Watch } from 'vue-property-decorator';
import { DataDesc, ColumnAppearance, DataType } from '../../../classes';
import { WxFabButton } from '../../layout';
import { WxIDataDialog } from '../wxDataDialog/WxIDataDialog';
import dayjs from 'dayjs';
import { debounce } from '../../../lib/debounce';

@Component({ name: 'wxDataTable', components: { itkFabButton: WxFabButton } })
export default class WxDataTable extends Vue {
    @Prop(Object) public dataDesc!: DataDesc;
    @Prop(String) private readonly title!: string;
    @Prop([String, Array]) private readonly privInsert!: string | string[];
    @Prop([String, Array]) private readonly privUpdate!: string | string[];
    @Prop([String, Array]) private readonly privDelete!: string | string[];
    @Prop(Array) private readonly headers!: object[];
    @Prop(String) private readonly itemType!: string;
    @Prop(Array) private readonly items!: [];
    @Prop(Boolean) private readonly loading!: [];
    @Prop(Object) private readonly dialogRef?: WxIDataDialog;
    @Prop({ default: 'header' }) private readonly crudStyle?: string;
    @Prop({ default: 500 }) private readonly searchDelay!: number;
    @PropSync('options', { type: Object }) private syncOptions!: any;
    @PropSync('selectedItem', { type: Object }) private syncSelectedItem!: any;

    private dayjs = dayjs;

    private DataType = DataType;

    private search = '';

    private debouncedSearch = '';
    private timeoutID: number | undefined;

    private footerProps = {
        itemsPerPageOptions: [10, 25, 50, -1],
    };

    private xParentHeight = 0;
    private xTableToolbarHeight = 0;

    @Watch('search')
    private onSearchChanged(val: string) {
        this.timeoutID = debounce(
            () => {
                this.debouncedSearch = val;
            },
            this.searchDelay,
            this.timeoutID
        );
    }

    private mounted() {
        this.hndlSync();
        this.retrieveHeights();
    }

    private updated() {
        this.retrieveHeights();
    }

    private get parent(): any {
        return this.$parent.$el as any;
    }

    private get tableToolbar(): any {
        return this.$refs.tableToolbar as any;
    }

    private retrieveHeights() {
        this.xParentHeight = this.parent.offsetHeight;
        this.xTableToolbarHeight = this.tableToolbar.clientHeight;
    }

    private get tableHeight() {
        return this.xParentHeight - this.xTableToolbarHeight - 60 + 'px';
    }

    private get columns() {
        const cols: object[] = this.headers ? this.headers : [];
        if (this.dataDesc) {
            for (const field of this.dataDesc.fields) {
                if (field.columnStyle > ColumnAppearance.Hidden) {
                    cols.push({
                        text: this.$t(field.caption),
                        value: field.fieldname,
                        class: field.css,
                        hint: this.$t(field.hint),
                        type: field.dataType,
                        icon: field.dataType === DataType.Icon ? field.fieldname : null,
                    });
                }
            }
            if (
                this.crudStyle === 'row' ||
                this.crudStyle === 'row-create-header' ||
                this.crudStyle === 'all' ||
                this.crudStyle === 'all-create-header'
            ) {
                cols.push({
                    class: 'text-xs-right',
                    sortable: false,
                    type: DataType.Action,
                });
            }
        }
        return cols;
    }

    private get primaryKey() {
        return !!this.dataDesc && !!this.dataDesc.primaryKey ? this.dataDesc.primaryKey : 'GUID';
    }

    private get hasInsert() {
        return this.privInsert;
    }

    private get hasUpdate() {
        return this.privUpdate;
    }

    private get hasDelete() {
        return this.privDelete;
    }

    private get canUpdate() {
        return !!this.syncSelectedItem.CAN_UPDATE;
    }

    private get canDelete() {
        return !!this.syncSelectedItem.CAN_DELETE;
    }

    private selectRow(item: any, select: (v: boolean) => void, $event: any) {
        this.syncSelectedItem = item;
        select($event);
    }

    @Emit('onSelect')
    private hndlSelect(item: any) {
        return item;
    }

    @Emit('onResync')
    private hndlSync() {
        return null;
    }

    @Emit('onInsert')
    private hndlInsert(event: any) {
        if (this.dialogRef) {
            this.dialogRef.showDialog(true);
        }
        return null;
    }

    @Emit('onUpdate')
    private hndlUpdate(event: any) {
        if (this.dialogRef) {
            this.dialogRef.showDialog(false);
        }
        return this.syncSelectedItem;
    }

    @Emit('onDelete')
    private hndlDelete() {
        return this.syncSelectedItem;
    }

    private debounceFn(fn: any, delay: number) {
        clearTimeout(this.timeoutID);
        this.timeoutID = window.setTimeout(() => {
            fn();
        }, delay);
    }

    private formatDateTime(val: string, pattern: string) {
        return val ? dayjs(val).format(pattern) : '';
    }

    private formatHeaderSlotName(val: string) {
        return 'header.' + val;
    }
}
